var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "50px 90px 70px 90px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.modoVer,
                                  expression: "modoVer"
                                }
                              ],
                              staticClass: "pr",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.nroCaso.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nroCaso.id
                                  ),
                                  "data-vv-name": _vm.formFields.nroCaso.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.nroCaso.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nroCaso,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nroCaso.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-flex", {
                            attrs: { xs12: "", sm12: "", md12: "" }
                          }),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80",
                                    expression: "'required|max:80'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  counter: "80",
                                  disabled: _vm.modoVer,
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80",
                                    expression: "'required|max:80'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.apellido.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.apellido.id
                                  ),
                                  "data-vv-name": _vm.formFields.apellido.id,
                                  counter: "80",
                                  disabled: _vm.modoVer,
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.formFields.apellido.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.apellido,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.apellido.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:11|telefonoFormato",
                                    expression:
                                      "'required|max:11|telefonoFormato'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.telefono.label,
                                  placeholder: "56999999999",
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.telefono.id
                                  ),
                                  "data-vv-name": _vm.formFields.telefono.id,
                                  counter: "11",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.telefono.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.telefono,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.telefono.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      email: true,
                                      max: 200,
                                      regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                                    },
                                    expression:
                                      "{\n                  email: true,\n                  max: 200,\n                  regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.([a-zA-Z]{2,4})+$/,\n                }"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.correoElectronico.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.correoElectronico.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.correoElectronico.id,
                                  counter: "200",
                                  disabled: _vm.modoVer,
                                  readonly: ""
                                },
                                model: {
                                  value: _vm.formFields.correoElectronico.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.correoElectronico,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.correoElectronico.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.categoria.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.categoria.id
                                  ),
                                  "data-vv-name": _vm.formFields.categoria.id,
                                  items: _vm.lstCategorias,
                                  "item-text": "categoria",
                                  "item-value": "idCategoria",
                                  disabled: _vm.modoVer
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.getSubCategorias(
                                      _vm.formFields.categoria.value
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.formFields.categoria.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.categoria,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.categoria.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.subCategoria.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.subCategoria.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.subCategoria.id,
                                  items: _vm.subfiltradas,
                                  "item-text": "subcategoria",
                                  "item-value": "idSubcategoria",
                                  disabled:
                                    _vm.modoVer ||
                                    _vm.formFields.categoria.value === ""
                                },
                                model: {
                                  value: _vm.formFields.subCategoria.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.subCategoria,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.subCategoria.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:80",
                                    expression: "'max:80'"
                                  },
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.modoVer,
                                    expression: "modoVer"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.titulo.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.titulo.id
                                  ),
                                  "data-vv-name": _vm.formFields.titulo.id,
                                  counter: "80",
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.titulo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.titulo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.titulo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-textarea", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:1000",
                                    expression: "'required|max:1000'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.descripcion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.descripcion.id
                                  ),
                                  "data-vv-name": _vm.formFields.descripcion.id,
                                  counter: "1000",
                                  readonly: _vm.modoVer,
                                  "auto-grow": true,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.descripcion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.descripcion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.descripcion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [_c("v-divider", { staticClass: "spacer" })],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.modoVer,
                                  expression: "modoVer"
                                }
                              ],
                              staticClass: "pr",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.estadoCaso.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.estadoCaso.id
                                  ),
                                  "data-vv-name": _vm.formFields.estadoCaso.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.estadoCaso.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.estadoCaso,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.estadoCaso.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.modoVer,
                                  expression: "modoVer"
                                }
                              ],
                              staticClass: "pl",
                              attrs: { xs6: "", sm6: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.fechaResolucion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.fechaResolucion.id
                                  ),
                                  "data-vv-name":
                                    _vm.formFields.fechaResolucion.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.fechaResolucion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaResolucion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaResolucion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.modoVer,
                                  expression: "modoVer"
                                }
                              ],
                              attrs: { xs12: "", sm12: "", md12: "" }
                            },
                            [
                              _c("v-textarea", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:1000",
                                    expression: "'max:1000'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.resolucion.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.resolucion.id
                                  ),
                                  "data-vv-name": _vm.formFields.resolucion.id,
                                  readonly: _vm.modoVer,
                                  "auto-grow": true,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.resolucion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.resolucion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.resolucion.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }